module.exports = __webpack_public_path__ + "img/icon_primary_menu_reports@2x.3db99543.png";